import HeadingCard from "./HeadingCard";

export default HeadingCard